// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ip-a";
export var fulfillmentFormRail = "_ip-9";
export var headerTitleRow = "_ip-c";
export var orderDetailsWrapper = "_ip-7";
export var orderLinkTrigger = "_ip-2";
export var paymentInformationGrid = "_ip-h";
export var paymentSummaryColumn = "_ip-i";
export var shipmentContainer = "_ip-b";
export var shipmentDetailsMainPane = "_ip-8";
export var shipmentNavigationCard = "_ip-5";
export var shipmentNavigationRail = "_ip-3";
export var shipmentNavigationRailHeader = "_ip-4";
export var shipmentSummaryFact = "_ip-e";
export var shipmentSummaryGrid = "_ip-d";
export var shipmentSummaryMetadataRow = "_ip-f";
export var shipmentSummaryTags = "_ip-g";
export var shipmentWorkspace = "_ip-0";
export var shipmentWorkspaceContent = "_ip-6";
export var shipmentWorkspaceHeader = "_ip-1";